import { validationConstants } from "constants/formValidation";
import useFormValidation from "hooks/useFormValidation";
import { Label } from "layout/typography/Label";
import { InputText } from "primereact/inputtext";
import { Controller, useFormContext } from "react-hook-form";
import { IDirectPayLinkPublicConfig } from "types/DirectPayLink.d";

interface IVisitInfoProps {
  linkConfig?: IDirectPayLinkPublicConfig | null;
  isInternalUser: boolean;
}

export function VisitInfo({ linkConfig, isInternalUser }: IVisitInfoProps) {
  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext();
  const { handleOnBlurField, getFormErrorMessage } = useFormValidation();

  // Hide account number field if link config says so
  const showAccountNumber = linkConfig ? linkConfig.showAccountNumber : true;

  // For public links, account number is optional
  // For internal use, account number is required
  const isAccountNumberOptional = !isInternalUser;

  if (!showAccountNumber) {
    return null;
  }

  return (
    <div className="field flex flex-column col-12 md:col-6">
      <Label htmlFor="accountNumber">
        Account Number{" "}
        {isAccountNumberOptional && (
          <span className="text-gray-500 text-sm">(Optional)</span>
        )}
      </Label>

      <Controller
        name="accountNumber"
        control={control}
        rules={
          !isAccountNumberOptional
            ? { required: validationConstants.VISIT_INFO_FORM.VISIT_ID }
            : undefined
        }
        render={({ field: { onChange, onBlur, value } }) => (
          <>
            <InputText
              data-testid="accountNumber"
              id="accountNumber"
              placeholder="Account Number"
              autoComplete="off"
              value={value || ""}
              onBlur={() =>
                handleOnBlurField({
                  onBlur,
                  field: "accountNumber",
                  trigger,
                })
              }
              onChange={(e) => onChange(e.target.value)}
            />

            {getFormErrorMessage("accountNumber", errors)}
          </>
        )}
      />
    </div>
  );
}
